export default __webpack_public_path__ + "static/media/icon-messenger.97dd9488.svg";